'use strict';

var _ = require('lodash');
var AlertsPanelController = function AlertsPanelController($scope, $rootScope, $state, alertsPanelDataService, constants, momentService, chartDashboardPerformanceService, transitionSearchCriteriaService, dashboardCommonService) {
  var NOT_FOUND_CLASS = 'alert-not-found-class';
  function updateGrid() {
    alertsPanelDataService.getData().then(updateGridData);
  }
  function updateGridData(alerts) {
    $scope.alerts = alerts;
    $scope.gridSettings.source = alerts[$scope.tab];
    $scope.alertsNumber = alerts[$scope.tab].length;
  }
  function updatePanelTitle() {
    var mapTitlePrefix = {};
    mapTitlePrefix[constants.ALERTS_TYPES.MARKET] = constants.ALERTS_PANEL_TITLE_PREFIX.MARKET;
    mapTitlePrefix[constants.ALERTS_TYPES.FLIGHT] = constants.ALERTS_PANEL_TITLE_PREFIX.FLIGHT;
    mapTitlePrefix[constants.ALERTS_TYPES.FARES] = constants.ALERTS_PANEL_TITLE_PREFIX.FARES;
    $scope.panelTitlePrefix = mapTitlePrefix[$scope.tab];
  }
  function switchGrid(newValue, oldValue) {
    if (newValue !== oldValue) {
      $scope.clearSelection(true);
      updatePanelTitle();
      updateGridData($scope.alerts);
    }
  }
  function hasSelectedRows() {
    return $scope.gridSettings.jqxGrid('selectedrowindexes').length > 0;
  }
  function getRuleTechnicalId(rule) {
    return rule.technicalId;
  }
  function getSelectedRulesIds() {
    var selectedRowIndexes = $scope.gridSettings.jqxGrid('selectedrowindexes') || [];
    return _.chain($scope.gridSettings.source).filter(function (el, ix) {
      return selectedRowIndexes.length === 0 || selectedRowIndexes.indexOf(ix) > -1;
    }).map(getRuleTechnicalId).uniq().value();
  }
  var getCellClassName = function getCellClassName(rowId, datafield) {
    if (datafield === 'name' && $scope.gridSettings.source[rowId].notFound === true) {
      return [NOT_FOUND_CLASS];
    }
    return [];
  };
  $scope.tab = 'marketAlerts';
  $scope.modeList = [{
    label: 'Market',
    value: constants.ALERTS_TYPES.MARKET
  }, {
    label: 'Flight',
    value: constants.ALERTS_TYPES.FLIGHT
  }, {
    label: 'Fares',
    value: constants.ALERTS_TYPES.FARES,
    feature: 'FIM'
  }];
  $scope.gridId = 'dashboard-alerts-grid';
  $scope.gridSettings = {
    width: '100%',
    height: '100%',
    altrows: true,
    selectionmode: 'checkbox_multiplerowsadvanced',
    columns: [{
      text: 'Alerts listing',
      dataField: 'name',
      cellsalign: 'left',
      textalign: 'left',
      cellclassname: getCellClassName
    }, {
      text: 'Value',
      dataField: 'score',
      width: 60,
      cellsalign: 'center',
      textalign: 'center'
    }]
  };
  $scope.navigateButtonVisible = false;
  $scope.panelOpened = false;
  $scope.rowSelectionChanged = function () {
    if ($scope.navigateButtonVisible !== hasSelectedRows()) {
      $scope.navigateButtonVisible = hasSelectedRows();
      $scope.$apply();
    }
  };
  $scope.resetGridPanel = function () {
    $scope.tab = constants.ALERTS_TYPES.MARKET;
    updatePanelTitle();
    updateGrid();
  };
  $scope.clearSelection = function (silent) {
    if (silent !== true || hasSelectedRows()) {
      $scope.navigateButtonVisible = false;
      $scope.gridSettings.jqxGrid('clearselection');
    }
  };
  $scope.navigateFromDashboardWithTransitionData = function () {
    var technicalIds = getSelectedRulesIds();
    var momentConfig = momentService.FIELD.DASHBOARD_DATE;
    var now = momentService.now(momentConfig);
    var curFullYear = now.year();
    var datesRanges = chartDashboardPerformanceService.getDatesRanges($scope.performanceChartSelectedMonths, curFullYear);
    var marketAndPosesBrush = dashboardCommonService.getMarketsAndPosesBrush();
    var searchCriteria;
    if ($scope.tab === 'marketAlerts') {
      searchCriteria = transitionSearchCriteriaService.dashboardMarketAlertsGridToMA(datesRanges, marketAndPosesBrush.market, marketAndPosesBrush.pos, technicalIds);
      goToScreen('app.market-analysis', searchCriteria);
    } else if ($scope.tab === 'flightAlerts') {
      searchCriteria = transitionSearchCriteriaService.dashboardFlightAlertsGridToFA(datesRanges, marketAndPosesBrush.market, technicalIds);
      goToScreen('app.flight-analysis', searchCriteria);
    } else if ($scope.tab === 'fimAlerts') {
      searchCriteria = transitionSearchCriteriaService.dashboardFaresAlertsGridToFIM(datesRanges, marketAndPosesBrush.market);
      goToScreen('app.fares', searchCriteria);
    }
  };
  function goToScreen(screenPath, searchCriteria) {
    $scope.hidePanel();
    $state.go(screenPath, {
      transitionData: {
        timestamp: momentService.now(momentService.FIELD.EVENT_TIME_STAMP),
        searchCriteria: searchCriteria
      }
    });
  }
  $scope.$watch('tab', switchGrid);
};
AlertsPanelController.$inject = ['$scope', '$rootScope', '$state', 'AlertsPanelDataService', 'DashboardConstants', 'MomentService', 'ChartDashboardPerformanceService', 'TransitionSearchCriteriaService', 'DashboardCommonService'];
module.exports = AlertsPanelController;